import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/free-solid-svg-icons'

type Rating = 0 | 1 | 2 | 3 | 4 | 5

interface IRatingProps extends React.HTMLProps<HTMLDivElement> {
  rating?: Rating
  onChangeRating?: (value: Rating) => void
  readOnly?: boolean
}

const numbers: Rating[] = [1, 2, 3, 4, 5]

const Rating: React.FC<IRatingProps> = ({
  rating = 0,
  onChangeRating,
  readOnly = false,
  ...rest
}) => {
  const [hovering, setHovering] = useState<number>()

  return (
    <div className='rating' {...rest}>
      {numbers.map((num) => (
        <div
          data-read-only={readOnly}
          className='rating-star-wrapper'
          onMouseOver={() => !readOnly && setHovering(num)}
          onMouseLeave={() => !readOnly && setHovering(undefined)}
          onClick={() => {
            if (onChangeRating && !readOnly) {
              if (rating === 1 && num === 1) {
                onChangeRating(0)
              } else {
                onChangeRating(num)
              }
            }
          }}
          key={num}
        >
          <FontAwesomeIcon
            className={`rating-star ${
              (!hovering && hovering !== 0 ? num <= rating : false) ||
              ((hovering || hovering === 0) && num <= hovering)
                ? 'rating-star-active'
                : ''
            }`}
            icon={faStar}
          />
        </div>
      ))}
    </div>
  )
}

export default Rating
